import type React from "react";

import { Modal, type ModalBaseProps } from "@/components/Modal/Modal";
import { Button } from "@/design-system/Button";
import { useTranslation } from "@/translations";

type EventDetailsConfirmExternalEventSignUpModalProps = ModalBaseProps;

export function EventDetailsConfirmExternalEventSignUpModal({
  isOpened,
  onOpenChange,
}: EventDetailsConfirmExternalEventSignUpModalProps): React.ReactNode {
  const { t } = useTranslation();

  return (
    <Modal.Root
      title={t("page.event.details.confirm-external-sign-up-modal-title")}
      description={t("page.event.details.confirm-external-sign-up-modal-description")}
      isOpened={isOpened}
      onOpenChange={onOpenChange}
      size="sm"
    >
      <Modal.Body>{null}</Modal.Body>
      <Modal.Actions>
        <Modal.Close>
          <Button>{t("common.action.got-it")}</Button>
        </Modal.Close>
      </Modal.Actions>
    </Modal.Root>
  );
}
